export type Round = 4 | 5 | 6;

export interface Fixture {
  opShort: string;
  venueId: string;
  round: Round;
  date: string; // 'YYYY-MM-DD' — locale-invariant; key into predictor.json `dates`
  kickoff: string;
  kickoffUtc: string;
}

export interface Team {
  short: string;
  hemisphere: 'north' | 'south';
  fixtures: [Fixture, Fixture, Fixture];
}

export const TEAMS_NORTH: Team[] = [
  {
    short: 'ENG',
    hemisphere: 'north',
    fixtures: [
      {
        opShort: 'AUS',
        venueId: 'allianz-stadium-london',
        round: 4,
        date: '2026-11-08',
        kickoff: '15:10',
        kickoffUtc: '15:10',
      },
      {
        opShort: 'JPN',
        venueId: 'allianz-stadium-london',
        round: 5,
        date: '2026-11-14',
        kickoff: '16:40',
        kickoffUtc: '16:40',
      },
      {
        opShort: 'NZL',
        venueId: 'allianz-stadium-london',
        round: 6,
        date: '2026-11-21',
        kickoff: '14:10',
        kickoffUtc: '14:10',
      },
    ],
  },
  {
    short: 'IRE',
    hemisphere: 'north',
    fixtures: [
      {
        opShort: 'ARG',
        venueId: 'aviva-stadium',
        round: 4,
        date: '2026-11-06',
        kickoff: '20:10',
        kickoffUtc: '20:10',
      },
      {
        opShort: 'FIJ',
        venueId: 'aviva-stadium',
        round: 5,
        date: '2026-11-14',
        kickoff: '20:10',
        kickoffUtc: '20:10',
      },
      {
        opShort: 'RSA',
        venueId: 'aviva-stadium',
        round: 6,
        date: '2026-11-21',
        kickoff: '16:40',
        kickoffUtc: '16:40',
      },
    ],
  },
  {
    short: 'SCO',
    hemisphere: 'north',
    fixtures: [
      {
        opShort: 'NZL',
        venueId: 'murrayfield',
        round: 4,
        date: '2026-11-07',
        kickoff: '14:10',
        kickoffUtc: '14:10',
      },
      {
        opShort: 'AUS',
        venueId: 'murrayfield',
        round: 5,
        date: '2026-11-15',
        kickoff: '15:10',
        kickoffUtc: '15:10',
      },
      {
        opShort: 'JPN',
        venueId: 'murrayfield',
        round: 6,
        date: '2026-11-21',
        kickoff: '14:10',
        kickoffUtc: '14:10',
      },
    ],
  },
  {
    short: 'WAL',
    hemisphere: 'north',
    fixtures: [
      {
        opShort: 'JPN',
        venueId: 'principality-stadium',
        round: 4,
        date: '2026-11-07',
        kickoff: '16:40',
        kickoffUtc: '16:40',
      },
      {
        opShort: 'NZL',
        venueId: 'principality-stadium',
        round: 5,
        date: '2026-11-14',
        kickoff: '14:10',
        kickoffUtc: '14:10',
      },
      {
        opShort: 'AUS',
        venueId: 'principality-stadium',
        round: 6,
        date: '2026-11-21',
        kickoff: '20:10',
        kickoffUtc: '20:10',
      },
    ],
  },
  {
    short: 'FRA',
    hemisphere: 'north',
    fixtures: [
      {
        opShort: 'FIJ',
        venueId: 'groupama-stadium',
        round: 4,
        date: '2026-11-07',
        kickoff: '21:10',
        kickoffUtc: '20:10',
      },
      {
        opShort: 'RSA',
        venueId: 'stade-de-france',
        round: 5,
        date: '2026-11-13',
        kickoff: '21:10',
        kickoffUtc: '20:10',
      },
      {
        opShort: 'ARG',
        venueId: 'stade-de-france',
        round: 6,
        date: '2026-11-21',
        kickoff: '21:10',
        kickoffUtc: '20:10',
      },
    ],
  },
  {
    short: 'ITA',
    hemisphere: 'north',
    fixtures: [
      {
        opShort: 'RSA',
        venueId: 'allianz-stadium-turin',
        round: 4,
        date: '2026-11-07',
        kickoff: '12:40',
        kickoffUtc: '11:40',
      },
      {
        opShort: 'ARG',
        venueId: 'stadio-luigi-ferraris',
        round: 5,
        date: '2026-11-14',
        kickoff: '12:40',
        kickoffUtc: '11:40',
      },
      {
        opShort: 'FIJ',
        venueId: 'bluenergy-stadium',
        round: 6,
        date: '2026-11-21',
        kickoff: '17:40',
        kickoffUtc: '16:40',
      },
    ],
  },
];

export const TEAMS_SOUTH: Team[] = [
  {
    short: 'NZL',
    hemisphere: 'south',
    fixtures: [
      {
        opShort: 'SCO',
        venueId: 'murrayfield',
        round: 4,
        date: '2026-11-07',
        kickoff: '14:10',
        kickoffUtc: '14:10',
      },
      {
        opShort: 'WAL',
        venueId: 'principality-stadium',
        round: 5,
        date: '2026-11-14',
        kickoff: '14:10',
        kickoffUtc: '14:10',
      },
      {
        opShort: 'ENG',
        venueId: 'allianz-stadium-london',
        round: 6,
        date: '2026-11-21',
        kickoff: '14:10',
        kickoffUtc: '14:10',
      },
    ],
  },
  {
    short: 'AUS',
    hemisphere: 'south',
    fixtures: [
      {
        opShort: 'ENG',
        venueId: 'allianz-stadium-london',
        round: 4,
        date: '2026-11-08',
        kickoff: '15:10',
        kickoffUtc: '15:10',
      },
      {
        opShort: 'SCO',
        venueId: 'murrayfield',
        round: 5,
        date: '2026-11-15',
        kickoff: '15:10',
        kickoffUtc: '15:10',
      },
      {
        opShort: 'WAL',
        venueId: 'principality-stadium',
        round: 6,
        date: '2026-11-21',
        kickoff: '20:10',
        kickoffUtc: '20:10',
      },
    ],
  },
  {
    short: 'RSA',
    hemisphere: 'south',
    fixtures: [
      {
        opShort: 'ITA',
        venueId: 'allianz-stadium-turin',
        round: 4,
        date: '2026-11-07',
        kickoff: '12:40',
        kickoffUtc: '11:40',
      },
      {
        opShort: 'FRA',
        venueId: 'stade-de-france',
        round: 5,
        date: '2026-11-13',
        kickoff: '21:10',
        kickoffUtc: '20:10',
      },
      {
        opShort: 'IRE',
        venueId: 'aviva-stadium',
        round: 6,
        date: '2026-11-21',
        kickoff: '16:40',
        kickoffUtc: '16:40',
      },
    ],
  },
  {
    short: 'ARG',
    hemisphere: 'south',
    fixtures: [
      {
        opShort: 'IRE',
        venueId: 'aviva-stadium',
        round: 4,
        date: '2026-11-06',
        kickoff: '20:10',
        kickoffUtc: '20:10',
      },
      {
        opShort: 'ITA',
        venueId: 'stadio-luigi-ferraris',
        round: 5,
        date: '2026-11-14',
        kickoff: '12:40',
        kickoffUtc: '11:40',
      },
      {
        opShort: 'FRA',
        venueId: 'stade-de-france',
        round: 6,
        date: '2026-11-21',
        kickoff: '21:10',
        kickoffUtc: '20:10',
      },
    ],
  },
  {
    short: 'FIJ',
    hemisphere: 'south',
    fixtures: [
      {
        opShort: 'FRA',
        venueId: 'groupama-stadium',
        round: 4,
        date: '2026-11-07',
        kickoff: '21:10',
        kickoffUtc: '20:10',
      },
      {
        opShort: 'IRE',
        venueId: 'aviva-stadium',
        round: 5,
        date: '2026-11-14',
        kickoff: '20:10',
        kickoffUtc: '20:10',
      },
      {
        opShort: 'ITA',
        venueId: 'bluenergy-stadium',
        round: 6,
        date: '2026-11-21',
        kickoff: '17:40',
        kickoffUtc: '16:40',
      },
    ],
  },
  {
    short: 'JPN',
    hemisphere: 'south',
    fixtures: [
      {
        opShort: 'WAL',
        venueId: 'principality-stadium',
        round: 4,
        date: '2026-11-07',
        kickoff: '16:40',
        kickoffUtc: '16:40',
      },
      {
        opShort: 'ENG',
        venueId: 'allianz-stadium-london',
        round: 5,
        date: '2026-11-14',
        kickoff: '16:40',
        kickoffUtc: '16:40',
      },
      {
        opShort: 'SCO',
        venueId: 'murrayfield',
        round: 6,
        date: '2026-11-21',
        kickoff: '14:10',
        kickoffUtc: '14:10',
      },
    ],
  },
];

export const ALL_TEAMS: Team[] = [...TEAMS_NORTH, ...TEAMS_SOUTH].sort((a, b) =>
  a.short.localeCompare(b.short),
);

export const SOUTHERN_TEAMS = new Set(['NZL', 'AUS', 'RSA', 'ARG', 'FIJ', 'JPN']);

// UK/Ireland venues are on GMT, so local kickoff time already equals UTC — no need to
// show a separate UTC time for fixtures hosted at these venues.
export const HIDE_UTC_LABEL_VENUES = new Set([
  'allianz-stadium-london',
  'aviva-stadium',
  'murrayfield',
  'principality-stadium',
]);

export function findTeamByShort(short: string): Team | undefined {
  return ALL_TEAMS.find((team) => team.short === short);
}

export function findFixture(short: string, round: Round): Fixture | undefined {
  return findTeamByShort(short)?.fixtures.find((f) => f.round === round);
}

export const SCORE_STEPS = [0, 3, 5, 6, 7] as const;
export const IMPOSSIBLE_SCORES = new Set([1, 2, 4]);

export function nextScore(v: number): number {
  if (v < 7) {
    const i = SCORE_STEPS.indexOf(v as (typeof SCORE_STEPS)[number]);
    return i < SCORE_STEPS.length - 1 ? SCORE_STEPS[i + 1] : 8;
  }
  return v < 120 ? v + 1 : 120;
}

export function prevScore(v: number): number {
  if (v <= 7) {
    const i = SCORE_STEPS.indexOf(v as (typeof SCORE_STEPS)[number]);
    return i > 0 ? SCORE_STEPS[i - 1] : 0;
  }
  return v - 1;
}

export const UNION_KEYS = [
  'argentina',
  'australia',
  'england',
  'fiji',
  'france',
  'ireland',
  'italy',
  'japan',
  'new_zealand',
  'scotland',
  'south_africa',
  'wales',
] as const;
export type UnionKey = (typeof UNION_KEYS)[number];

export const UNION_SHORTS: Record<UnionKey, string> = {
  argentina: 'UAR',
  australia: 'RA',
  england: 'RFU',
  fiji: 'FRU',
  france: 'FFR',
  ireland: 'IRFU',
  italy: 'FIR',
  japan: 'JRFU',
  new_zealand: 'NZR',
  scotland: 'SRU',
  south_africa: 'SARU',
  wales: 'WRU',
};

export const TEAM_LOGO_FILES: Record<string, { mono: string; colour: string }> = {
  ARG: { mono: 'arg-los-pumas-mono', colour: 'arg-los-pumas' },
  AUS: { mono: 'aus-wallabies-mono', colour: 'aus-wallabies' },
  ENG: { mono: 'eng-roses-mono', colour: 'eng-roses' },
  FIJ: { mono: 'fiji-rugby-mono', colour: 'fiji-rugby' },
  FRA: { mono: 'france-rugby-mono', colour: 'france-rugby' },
  IRE: { mono: 'ire-irfu-mono', colour: 'ire-irfu' },
  ITA: { mono: 'ita-rugby-mono', colour: 'ita-rugby' },
  JPN: { mono: 'jpn-rugby-mono', colour: 'jpn-rugby' },
  NZL: { mono: 'nzl-blacks-mono', colour: 'nzl-blacks' },
  RSA: { mono: 'rsa-rugby-mono', colour: 'rsa-rugby' },
  SCO: { mono: 'sco-rugby-mono', colour: 'sco-rugby' },
  WAL: { mono: 'wal-rugby-mono', colour: 'wal-rugby' },
};

export const UNION_TO_TEAM_SHORT: Record<UnionKey, string> = {
  argentina: 'ARG',
  australia: 'AUS',
  england: 'ENG',
  fiji: 'FIJ',
  france: 'FRA',
  ireland: 'IRE',
  italy: 'ITA',
  japan: 'JPN',
  new_zealand: 'NZL',
  scotland: 'SCO',
  south_africa: 'RSA',
  wales: 'WAL',
};
